import { Preloader } from 'components/common';
import 'normalize.css/normalize.css';
import React from 'react';
import { render } from 'react-dom';
import 'react-phone-input-2/lib/style.css';
import { onAuthStateFail, onAuthStateSuccess } from 'redux/actions/authActions';
import configureStore from 'redux/store/store';
import 'style/style.scss';
import WebFont from 'webfontloader';
import { onAuthStateChanged } from 'firebase/auth';
import App from './App';
import firebase from './firebase/firebase';
import './i18n';

WebFont.load({
  google: {
    families: ['Poppins']
  }
});

const { store, persistor } = configureStore();
const root = document.getElementById('app');

render(<Preloader />, root);
onAuthStateChanged(firebase.auth, async (user) => {
  const res = await firebase.getClientLocation();
  if (res === null) {
    return;
  }
  if (user) {
    store.dispatch(onAuthStateSuccess(user));
  } else {
    store.dispatch(onAuthStateFail('Error'));
  }
  render(<App store={store} persistor={persistor} />, root);
});

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        // eslint-disable-next-line no-console
        console.log(registration);
      })
      .catch((e) => {
        console.error(e);
      });
  });
}
